import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";

interface LoadingAlertProps {
	error?: Error;
}

export default function LoadingAlert(props: LoadingAlertProps) {
	return props.error ? (
		<Alert variant="danger">
			<i className="bi bi-exclamation-triangle-fill me-1" />
			<span className="user-select-text">
				<b>Ladefehler</b>: {props.error.message}
			</span>
		</Alert>
	) : (
		<Alert variant="success">
			<Spinner className="me-1" animation="border" size="sm" />
			<span className="user-select-text">Wird geladen...</span>
		</Alert>
	);
}
